import _ from "lodash";

export function sortUsersByName(users) {
  return _.sortBy(users, user => user.full_name.toLowerCase());
}

export function sortUsersByStatus(users) {
  return _.sortBy(users, user => user.status);
}
